"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { NumberInput as HeroNumberInput } from '@heroui/react';
export const NumberInput = ({ value, onValueChange, ...rest }) => {
    const baseId = useId();
    const hasValue = value !== undefined;
    const instanceKey = `${baseId}-${hasValue ? 'controlled' : 'uncontrolled'}`;
    const handleValueChange = useCallback((newValue) => {
        if (newValue === null) {
            onValueChange?.(undefined);
        }
        else {
            onValueChange?.(newValue);
        }
    }, [onValueChange]);
    if (hasValue) {
        return (_jsx(HeroNumberInput, { ...rest, value: value, onValueChange: handleValueChange }, instanceKey));
    }
    return (_jsx(HeroNumberInput, { ...rest, onValueChange: handleValueChange }, instanceKey));
};
//# sourceMappingURL=NumberInput.js.map